/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type CSSProperties, type FC, type JSX } from 'react';

// eslint-disable-next-line import/no-cycle
import { camelToTitle } from '../../../helpers/utils';
import CheckIcon from '../Icon';
import Toggle from '../Toggle';
import { FieldType } from '../../../index';
import { LabelStyled, Text } from './styled';

type LabelProps = {
  name: string;
  label?: {
    style: CSSProperties;
    text: string | JSX.Element;
  };
  setValue: React.Dispatch<React.SetStateAction<boolean>>;
  customSvg?: {
    svgProps: {
      width: number;
      height: number;
      viewBox: string;
    };
    forTrue: any;
    forFalse: any;
  };
  labelId: string;
  value: boolean;
  type?: FieldType;
  disabled?: boolean;
};

const Label: FC<LabelProps> = (props) => {
  const { name, label, value, labelId, setValue, customSvg, type, disabled } = props;
  const ariaLabel = camelToTitle({
    str: label && label.text && typeof label.text === 'string' ? label.text : undefined,
    name,
  });
  const isToggle = type && type === FieldType.TOGGLE;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLLabelElement>) => {
    switch (e.key) {
      case 'Enter':
      case ' ':
      case 'ArrowLeft':
      case 'ArrowRight':
        e.preventDefault();
        setValue(!value);
        break;
      default:
        break;
    }
  };

  return (
    <LabelStyled
      {...{
        id: labelId,
        htmlFor: name,
        style: label && label.style,
        value,
        role: isToggle ? 'switch' : 'checkbox',
        'aria-checked': value,
        ...(disabled
          ? { 'aria-disabled': true, 'aria-label': ariaLabel }
          : {
              tabIndex: 0,
              'aria-label': ariaLabel,
              onKeyDown: (e: React.KeyboardEvent<HTMLLabelElement>) => handleKeyDown(e),
            }),
      }}
    >
      <>
        {!isToggle && <CheckIcon {...{ customSvg, labelId, value }} className="check-icon-checkbox" />}
        <Text>{label && label.text}</Text>
        {isToggle && <Toggle value={value} setValue={setValue} disabled={disabled} />}
      </>
    </LabelStyled>
  );
};

export default Label;
